import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { Header, HeaderProps } from '../../../../ui/header/Header';
import { BillingBreadcrumbs } from './BillingBreadcrumbs';
import { BillingHeaderTabs, billingSections } from './BillingHeaderTabs';

export const BillingHeader = ({
  ...props
}: Pick<HeaderProps, 'scrollableDivRef' | 'buttons'>) => {
  const intl = useIntl();
  const {
    location: { pathname },
  } = useHistory();

  const currentSection = useMemo(() => {
    const sectionInUrl = pathname.split('/').pop();
    return (
      billingSections.find(el => el.route === sectionInUrl) ??
      billingSections[0]
    );
  }, [pathname]);

  return (
    <Header
      {...props}
      tabs={<BillingHeaderTabs currentSection={currentSection} />}
      title={intl.formatMessage({
        id: `containers.billing.${currentSection.label}`,
      })}
      description={intl.formatMessage({
        id: 'containers.billing.description',
      })}
      breadcrumbs={
        <BillingBreadcrumbs
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: `containers.billing.${currentSection.label}`,
              }),
            },
          ]}
        />
      }
    />
  );
};
